import '../FaqCard.scss';

import { Info } from '@phosphor-icons/react';
import { Trans, useTranslation } from 'react-i18next';

const className = 'c-FaqCard';

const FaqCardEsimPlanInfo = () => {
  const { t } = useTranslation();

  return (
    <div>
      <div className={`${className}__center`}>
        <Info size={48} aria-hidden="true" />
      </div>

      <h2 className={`${className}__faq_card_title`}>
        {t('landing.esim_explained_card3.title', 'How our plans work')}
      </h2>
      <p>
        {t(
          'landing.esim_modal3.1',
          'All plans come with a validity period in days, which refers to how many days you may use the plan for.',
        )}
      </p>

      <p>
        <Trans
          i18nKey="landing.esim_modal3.2"
          defaults={
            'The validity period will start when you install your plan <strong> or </strong> when you arrive at your destination, depending on the provider.'
          }
        />
      </p>
      <p>
        {t(
          'landing.esim_modal3.3',
          'Your plan details will state when the validity period starts.',
        )}
      </p>
    </div>
  );
};

export default FaqCardEsimPlanInfo;
